














































import Vue, { PropType } from 'vue';
import { EVoucherType } from '@ringana/configs';
import FormatHelper from '@/helpers/FormatHelper';
import TeamSelect from '../../layout/inputs/TeamSelect.vue';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import VoucherAssignmentFailedMessage from './VoucherAssignmentFailedMessage.vue';

interface ICodeBasedVoucherAssignmentComponent {
  selectedCustomerName: string;
  selectedCustomerNumber: number;
}

export default Vue.extend({
  components: { CustomButton, TeamSelect, VoucherAssignmentFailedMessage },
  data(): ICodeBasedVoucherAssignmentComponent {
    return {
      selectedCustomerName: ``,
      selectedCustomerNumber: -1,
    };
  },
  computed: {
    formattedVoucherValue(): string {
      if(!this.voucherType) {
        return ``;
      }

      return FormatHelper.formatVoucherValue(this.voucherValue, this.voucherType);
    },
  },
  props: {
    showAssignmentError: {
      default: false,
      type: Boolean,
    },
    voucherType: {
      default: null,
      type: String as PropType<EVoucherType | null>,
      validator(val: EVoucherType | null): boolean {
        return val === null || Object.values(EVoucherType).includes(val);
      },
    },
    voucherValue: {
      required: true,
      type: Number,
    },
  },
  methods: {
    selectCustomer(customer: { customerNumber: number; label: string }): void {
      this.selectedCustomerName = customer.label.substr(0, customer.label.indexOf(` - `));
      this.selectedCustomerNumber = customer.customerNumber;
    },
  },
});
